export default defineNuxtPlugin((nuxtApp) => { 
    // Also possible
    nuxtApp.hook('vue:error', (error, instance, info) => {
      // handle error, e.g. report to a service
      console.log("Plugin Error Handler");
      console.error('Vue error:', error);
    })
  })